export default __webpack_public_path__ + "static/media/air_speed.ea09e9aa.svg";